module.exports = __webpack_public_path__ + "img/NG.6cd77286.svg";